
/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */


import {CameraSettingLoadedActionFail, CameraSettingLoadedActionInProgress, CameraSettingLoadedActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';

/**
 * @function CameraSettingLoadedActionCreator
 * @param {}
 * @return {Promise<any>}  Promise
 */
export function CameraSettingLoadedActionCreator(): (
    dispatch: Dispatch<any>, {}) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(CameraSettingLoadedActionInProgress());

    try {
      const data = 'chargement des parametres camera !!!!!!! ';
      await dispatch(CameraSettingLoadedActionSuccess(data));

    } catch (error) {
      dispatch(CameraSettingLoadedActionFail(
          error.message + ' ,random value:' + Math.random()));
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/supervision/camera/settings/index.ts